import RaikoBaseDialogContentContainer
    from "../../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";
import {
    RaikoGridThreeColumn,
    RaikoMaterialOutlinedInput,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    RaikoToggleOutlined, showServerErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {AppVersionService} from "../../../serverService/appVersionService/AppVersionService";

export default function AddNewAppVersion({handleCloseDialog,handleAddNewVersionApp}) {

    const service = new AppVersionService()

    const [appTitle, setAppTitle] = useState("");
    const [appVersionCode, setAppVersionCode] = useState("");
    const [appMinimumVersionCode, setAppMinimumVersionCode] = useState("");
    const [appDescription, setAppDescription] = useState("");
    const [appEnabled, setAppEnabled] = useState(false);
    const [appMandatory, setAppMandatory] = useState(false);
    const [appStorePublishedState, setAppStorePublishedState] = useState(false);
    const [actionButtonLoading, setActionButtonLoading] = useState(false)

    function handleAddNewAppVersion() {
        setActionButtonLoading(true)
        service.addNewAppVersion(
            appTitle,
            appVersionCode,
            appMinimumVersionCode,
            appEnabled,
            appStorePublishedState,
            appMandatory,
            appDescription
        ).then(response => {
            handleAddNewVersionApp(response)
            showSuccessMessage("نسخه ی جدید با موفقیت افزوده شد.")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }

    return (
        <RaikoBaseDialogContentContainer>
            <RaikoSectionContainer
                title={"افزودن نسخه جدید"}
                hasActionButton
                actionButtonTitle={"افزودن"}
                actionButtonLoadingState={actionButtonLoading}
                actionButtonOnclickWithValidation={handleAddNewAppVersion}
                hasSecondaryButton
                secondaryButtonTitle={"بازگشت"}
                secondaryButtonOnClick={handleCloseDialog}
            >
                <RaikoGridThreeColumn>
                    <RaikoSimpleInputOutlined
                        labelText={"نام نسخه"}
                        value={appTitle}
                        setValue={setAppTitle}
                        required
                    />
                    <RaikoNumberInputOutlined
                        labelText={"شماره نسخه"}
                        value={appVersionCode}
                        setValue={setAppVersionCode}
                        required
                    />
                    <RaikoNumberInputOutlined
                        labelText={"حداقل نسخه مجاز"}
                        value={appMinimumVersionCode}
                        setValue={setAppMinimumVersionCode}
                        required
                    />
                    <RaikoToggleOutlined
                        labelText={"وضعیت (فعال/غیرفعال)"}
                        setChecked={setAppEnabled}
                        checked={appEnabled}
                    />
                    <RaikoToggleOutlined
                        labelText={"بروزرسانی (اجباری/اختیاری)"}
                        setChecked={setAppMandatory}
                        checked={appMandatory}
                    />
                    <RaikoToggleOutlined
                        labelText={"وضعیت انتشار کافه بازار"}
                        setChecked={setAppStorePublishedState}
                        checked={appStorePublishedState}
                    />
                </RaikoGridThreeColumn>
                <RaikoSimpleMultiLineInputOutlined
                    labelText={"توضیحات"}
                    setValue={setAppDescription}
                    value={appDescription}
                />
            </RaikoSectionContainer>
        </RaikoBaseDialogContentContainer>
    )
}